import { render, staticRenderFns } from "./ContactDataManualSection.vue?vue&type=template&id=e97166ee&"
import script from "./ContactDataManualSection.vue?vue&type=script&lang=js&"
export * from "./ContactDataManualSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports